/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_Counter_Enums_Markets } from '../models/Gsoa_Counter_Enums_Markets';
import type { Gsoa_Coupons_Enums_GetAllActivityTypes_response } from '../models/Gsoa_Coupons_Enums_GetAllActivityTypes_response';
import type { Gsoa_Coupons_Enums_GetAllAssignments_response } from '../models/Gsoa_Coupons_Enums_GetAllAssignments_response';
import type { Gsoa_Coupons_Enums_GetAllAssortments_response } from '../models/Gsoa_Coupons_Enums_GetAllAssortments_response';
import type { Gsoa_Coupons_Enums_GetAllCategories_response } from '../models/Gsoa_Coupons_Enums_GetAllCategories_response';
import type { Gsoa_Coupons_Enums_GetAllDiscountLabelTypes_response } from '../models/Gsoa_Coupons_Enums_GetAllDiscountLabelTypes_response';
import type { Gsoa_Coupons_Enums_GetAllDiscountTypes_response } from '../models/Gsoa_Coupons_Enums_GetAllDiscountTypes_response';
import type { Gsoa_Coupons_Enums_GetAllDistribution_response } from '../models/Gsoa_Coupons_Enums_GetAllDistribution_response';
import type { Gsoa_Coupons_Enums_GetAllStates_response } from '../models/Gsoa_Coupons_Enums_GetAllStates_response';
import type { Gsoa_Coupons_Enums_GetAllUse_response } from '../models/Gsoa_Coupons_Enums_GetAllUse_response';
import type { Gsoa_CustomerProfile_Enums_CardStatuses } from '../models/Gsoa_CustomerProfile_Enums_CardStatuses';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaEnumsService {
    /**
     * Dictionary for activity types
     * @returns Gsoa_Coupons_Enums_GetAllActivityTypes_response OK
     * @throws ApiError
     */
    public static getEnumsActivityTypes({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllActivityTypes_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/activityTypes',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for assignments
     * @returns Gsoa_Coupons_Enums_GetAllAssignments_response OK
     * @throws ApiError
     */
    public static getEnumsAssignments({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllAssignments_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/assignments',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for Assortments
     * @returns Gsoa_Coupons_Enums_GetAllAssortments_response OK
     * @throws ApiError
     */
    public static getEnumsAssortments({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllAssortments_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/assortments',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for categories
     * @returns Gsoa_Coupons_Enums_GetAllCategories_response OK
     * @throws ApiError
     */
    public static getEnumsCategories({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllCategories_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/categories',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for card statuses
     * @returns Gsoa_CustomerProfile_Enums_CardStatuses OK
     * @throws ApiError
     */
    public static getEnumsCardStatuses({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_CustomerProfile_Enums_CardStatuses> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/cardStatuses',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for Discount label types
     * @returns Gsoa_Coupons_Enums_GetAllDiscountLabelTypes_response OK
     * @throws ApiError
     */
    public static getEnumsDiscountLabelTypes({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllDiscountLabelTypes_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/discountLabelTypes',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for discount types
     * @returns Gsoa_Coupons_Enums_GetAllDiscountTypes_response OK
     * @throws ApiError
     */
    public static getEnumsDiscountTypes({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllDiscountTypes_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/discountTypes',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for distributions
     * @returns Gsoa_Coupons_Enums_GetAllDistribution_response OK
     * @throws ApiError
     */
    public static getEnumsDistributions({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllDistribution_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/distributions',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary of markets.
     * @returns Gsoa_Counter_Enums_Markets OK
     * @throws ApiError
     */
    public static getEnumsMarkets({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Counter_Enums_Markets> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/markets',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for coupon states
     * @returns Gsoa_Coupons_Enums_GetAllStates_response OK
     * @throws ApiError
     */
    public static getEnumsStates({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllStates_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/states',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Dictionary for uses
     * @returns Gsoa_Coupons_Enums_GetAllUse_response OK
     * @throws ApiError
     */
    public static getEnumsUses({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_Coupons_Enums_GetAllUse_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/uses',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
